export default {
  env: 'local',
  assetsEndpoint: 'https://static.dev.mdirector.com/assets/',
  storage: {
    domain: 'http://localhost:3000',
    file: '/storage.html',
  },
  services: {
    email_marketing: { frontUrl: 'http://localhost:3000' },
    email_transactional: { frontUrl: 'http://localhost:3000' },
    marketing_automation: { frontUrl: 'http://localhost:3000' },
    landing_optimizer: { frontUrl: 'http://localhost:3000' },
    payments: { frontUrl: 'http://localhost:3000' },
    integrations: {
      frontUrl: 'http://localhost:3000',
      zapier: true,
      shopify: true,
      apis: true,
    },
  },
};
